<script>
import { Pie, mixins } from 'vue-chartjs'
//import ChartDataLabels from 'chartjs-plugin-datalabels'

const { reactiveProp } = mixins

export default {
  extends: Pie,
  mixins: [reactiveProp],
  //plugins: [ChartDataLabels],
  props: ['options'],
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    // this.options.tooltips = {
    //   // Disable the on-canvas tooltip
    //   enabled: false,

    //   custom: function(tooltipModel) {
    //     // Tooltip Element
    //     var tooltipEl = document.getElementById('chartjs-tooltip')

    //     // Create element on first render
    //     if (!tooltipEl) {
    //       tooltipEl = document.createElement('div')
    //       tooltipEl.id = 'chartjs-tooltip'
    //       tooltipEl.innerHTML = '<table></table>'
    //       document.body.appendChild(tooltipEl)
    //     }

    //     // Hide if no tooltip
    //     if (tooltipModel.opacity === 0) {
    //       tooltipEl.style.opacity = 0
    //       return
    //     }

    //     // Set caret Position
    //     tooltipEl.classList.remove('above', 'below', 'no-transform')
    //     if (tooltipModel.yAlign) {
    //       tooltipEl.classList.add(tooltipModel.yAlign)
    //     } else {
    //       tooltipEl.classList.add('no-transform')
    //     }

    //     function getBody(bodyItem) {
    //       return bodyItem.lines
    //     }

    //     // Set Text
    //     if (tooltipModel.body) {
    //       var titleLines = tooltipModel.title || []
    //       var bodyLines = tooltipModel.body.map(getBody)

    //       var innerHtml = '<thead>'

    //       titleLines.forEach(function(title) {
    //         innerHtml += '<tr><th>' + title + '</th></tr>'
    //       })
    //       innerHtml += '</thead><tbody>'

    //       bodyLines.forEach(function(body, i) {
    //         var colors = tooltipModel.labelColors[i]
    //         var style = 'background:' + colors.backgroundColor
    //         style += '; border-color:' + colors.borderColor
    //         style += '; border-width: 2px'
    //         var span = '<span style="' + style + '"></span>'
    //         innerHtml += '<tr><td>' + span + body + '</td></tr>'
    //       })
    //       innerHtml += '</tbody>'

    //       var tableRoot = tooltipEl.querySelector('table')
    //       tableRoot.innerHTML = innerHtml
    //     }

    //     // `this` will be the overall tooltip
    //     var position = this._chart.canvas.getBoundingClientRect()

    //     //Ensure Tooltip stays in view at top and bottom most positions

    //     const toolHeight = tooltipModel.height
    //     const graphHeight = this._chart.height
    //     const caretYPosition = tooltipModel.caretY
    //     const maxYPosition = graphHeight - toolHeight
    //     const normalizedYPosition = caretYPosition + position.top

    //     if (caretYPosition >= maxYPosition) {
    //       const yDif = caretYPosition - maxYPosition
    //       tooltipEl.style.top = normalizedYPosition - (yDif + padding) + 'px'
    //     } else {
    //       tooltipEl.style.top = `${normalizedYPosition}px`
    //     }

    //     // Display, position, and set styles for font
    //     tooltipEl.style.opacity = 1
    //     tooltipEl.style.position = 'absolute'
    //     tooltipEl.style.left =
    //       position.left + window.pageXOffset + tooltipModel.caretX + 'px'
    //     tooltipEl.style.top =
    //       position.top + window.pageYOffset + tooltipModel.caretY + 'px'
    //     tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily
    //     tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px'
    //     tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle
    //     tooltipEl.style.padding =
    //       tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px'
    //     tooltipEl.style.pointerEvents = 'none'
    //     tooltipEl.style.backgroundColor = '#FFF'
    //     tooltipEl.style.titleFontSize = 10
    //     tooltipEl.style.titleFontColor = '#000'
    //     tooltipEl.style.bodyFontColor = '#000'
    //     tooltipEl.style.bodyFontSize = 12
    //     tooltipEl.style.displayColors = false
    //     tooltipEl.style.border = 'solid'
    //     tooltipEl.style.borderColor = '#000'
    //     tooltipEl.style.borderRadius = '3px'
    //     tooltipEl.style.borderWidth = '0 0.5px 0.5px 0px'
    //   }
    // }
    this.renderChart(this.chartData, this.options)
  }
}
</script>
